import type { UserRole } from '@lmc/ts-common'

export enum CapabilityKey {
  SafeguardingOversight = 'safeguardingOversight',
  TeamManagement = 'teamManagement',
  ServiceUserManagement = 'serviceUserManagement',
  IncidentManagement = 'incidentManagement',
  DownloadCentreAccess = 'downloadCentreAccess',
  MedicationManagement = 'medicationManagement'
}

// IT & Security is part of the design's 6-role roster but isn't yet in
// @lmc/ts-common's UserRole enum (or @lmc/validations' UserRoleEnum) —
// CM-2888 ships that. Until then the wizard carries the literal
// 'it-security' identifier the rest of the codebase already uses
// (see ROLE_TAB_TO_USER_ROLE in screens/.../utils/roleTabs.ts).
export type WizardRole = UserRole | 'it-security'

// CM-3388: scopes the Add-member wizard's role roster + create payload.
//   single-site     → existing TeamListV2 behaviour (no home/homeGroup)
//   specific-sites  → site roster + required Site multi-select → home: homes[0]
//   group-dashboard → group roles only, no Site field → homeGroup from viewer
export type RoleRosterScope =
  | 'single-site'
  | 'specific-sites'
  | 'group-dashboard'

export type ToggleConfig = {
  key: CapabilityKey
  labelKey: string // UPPER_SNAKE_CASE key from teamConstants — resolved via t() in Step 3 component
  bullets: { variant: 'tick' | 'cross'; copyKey: string }[]
  defaultValue: boolean
  permissionId?: string // omitted for medicationManagement (boolean field)
}
